import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { getPathname, hasDirectVideoExtension, isVideoContentType } from '../utils/contentType';

export class DirectFileResolver implements MediaResolver {
  name = 'DirectFileResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    const { url } = context.input;
    const pathname = getPathname(url);

    if (hasDirectVideoExtension(pathname) || hasDirectVideoExtension(url)) {
      return true;
    }

    try {
      const content = await context.fetchContent(url);

      return isVideoContentType(content.contentType) && !content.contentType?.includes('mpegurl');
    } catch {
      return hasDirectVideoExtension(pathname);
    }
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const { url, thumbnailUrl, title, description } = context.input;

    return {
      mediaType: 'video',
      playerType: 'html5',
      playbackUrl: url,
      thumbnailUrl: thumbnailUrl ?? undefined,
      title: title ?? undefined,
      description: description ?? undefined,
      resolved: true,
      resolverName: this.name,
      metadata: {
        streamFormat: 'progressive',
      },
    };
  }
}
